export const ShellEnvironment = {
  DEFAULT: 'DEFAULT' as const,
  EMBEDDED: 'EMBEDDED' as const,
  PUBLIC: 'PUBLIC' as const,
  TERMINAL: 'TERMINAL' as const,
};

export type ShellEnvironment = keyof typeof ShellEnvironment;
